<template>
    <v-card flat min-height="305" class="mr-1">
        <v-card-title class="text--darken-2 font-weight-bold grey--text text-sm-body-2">
            Próximas Licenças a Vencer
        </v-card-title>
        <v-divider/>
        <v-row
            class="mx-1 text--darken-2 grey--text text-sm-body-2 styleCard"
            @click="acessarLicenca(patrimonio.id)"
            v-for="(patrimonio, index) in licencas"
            :key="index">
            <v-col cols="6">
                <span class="d-inline-block text-truncate" style="max-width: 13vw">
                    {{ patrimonio.nome }}
                </span>
            </v-col>
            <v-col cols="4">
                {{ patrimonio.valorEntrada | valorParaDinheiro }}
            </v-col>
            <v-col cols="2" :class="patrimonio.diasParaVencer <= 30 ? 'red--text text-right' : 'text-right'">
                {{ patrimonio.diasParaVencer | formatarText() }}
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
    export default {
        name: 'Dashboard',
        props: ['licencas'],
        filters: {
            formatarText(qtdDias) {
                return qtdDias === 1 ? `${qtdDias}  dia` : `${qtdDias}  dias`
            }
        },
        methods: {
            acessarLicenca(idLicenca) {
                this.$emit('acessarLicenca', idLicenca)
            }
        }
    }
</script>

<style lang="stylus">
    .styleCard
        cursor: pointer

    .styleCard:hover
        background-color #eee
</style>
